<template>
  <div class="const">
    <div class="sear">
      <label>从</label>
      <el-date-picker v-model="startDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <label>到</label>
      <el-date-picker v-model="endDate" type="date" placeholder="选择日期" style="width:150px"></el-date-picker>
      <el-button type="primary" style="margin-left:20px;" v-on:click="tionSears()">确定</el-button>
    </div>
    <div
      class="jtCon"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.3)"
    >
      <el-collapse v-model="activeNames" style="width:100%">
        <el-collapse-item v-for="item in videoLIst" v-bind:key="item.id" :name="item.id">
          <template slot="title">
            <div class="j_tit">
              {{item.r_username}}
              <label>{{item.r_time}}</label>
            </div>
          </template>
          <div class="j_con">
            <label v-if="item.r_sub == 0">未知文件操作</label>
            <label v-if="item.r_sub == 1">创建文件</label>
            <label v-if="item.r_sub == 2">创建文件夹</label>
            <label v-if="item.r_sub == 3">拷贝文件</label>
            <label v-if="item.r_sub == 4">拷贝文件夹</label>
            <label v-if="item.r_sub == 5">移动文件</label>
            <label v-if="item.r_sub == 6">移动文件夹</label>
            <label v-if="item.r_sub == 7">文件重命名</label>
            <label v-if="item.r_sub == 8">文件夹重命名</label>
            <label v-if="item.r_sub == 9">删除文件</label>
            <label v-if="item.r_sub == 10">删除文件夹</label>
            {{item.r_data}}
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-pagination
      small
      layout="prev, pager, next"
      :total="total"
      :page-size="pagesize"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>
<script>
import { http } from "./../../https";
export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      videoLIst: [],
      srcList: [],
      page: 0,
      pagesize: 8,
      total: 0,
      loading: false,
      activeNames: []
    };
  },
  created() {
    let timeStamp = new Date(new Date().setHours(0, 0, 0, 0)) / 1000;
    let SevenDayAgo = timeStamp - 86400 * 7;
    let start_time = SevenDayAgo;
    this.startDate = this.timestampToTime(start_time);
    let end_time =
      new Date(new Date().setHours(23, 59, 59, 0)).getTime() / 1000;
    this.endDate = this.timestampToTime(end_time);
    this.tionSear();
  },
  methods: {
    tionSears() {
      this.page = 0;
      this.tionSear();
    },
    tionSear() {
      const user_name = sessionStorage.getItem("user_name");
      const mac = sessionStorage.getItem("mac");
      const oauth_token = sessionStorage.getItem("oauth_token");
      this.loading = true;
      const type = 4;
      const subtype = 1;
      let macSplit = mac.replace(/-/g, "");
      let start_time = new Date(this.startDate).getTime() / 1000;
      let end_time = new Date(this.endDate).getTime() / 1000;
      const page = this.page;
      const pageSize = this.pagesize;
      let url = `http://${user_name}_${macSplit}.ng.360mon.cn:90/index.php?class=record&act=getLogRecord&mac=${mac}&oauth_token=${oauth_token}&type=${type}&subtype=${subtype}&page=${page}&page_count=${pageSize}&start_time=${start_time}&end_time=${end_time}`;
      http({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        }
      })
        .then(res => {
          if (res.data.table.length > 0) {
            for (let o = 0; o < res.data.table.length; o++) {
              res.data.table[o].r_time = this.timestampToTime(
                res.data.table[o].r_time
              );
              res.data.table[o].id = o;
              this.activeNames.push(res.data.table[o].id);
            }
          }
          this.loading = false;
          this.videoLIst = res.data.table;
          this.total = res.data.total;
        })
        .catch(res => {
          this.loading = false;
          console.log(res);
        });
    },
    handleCurrentChange(e) {
      this.page = e - 1;
      this.tionSear();
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>
<style scoped>
.const {
  background: #ffffff;
  height: 100%;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: auto;
}
.const .sear {
  margin-left: 26px;
  font-size: 15px;
  font-weight: 400;
  color: rgba(141, 141, 141, 1);
  padding-top: 20px;
}
.const .sear label {
  margin: 0 15px;
}
.const .jtCon {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 15px 26px 0 26px;
  height: calc(100vh - 350px);
  overflow: auto;
}
.const .jtCon .j_tit {
  font-size: 15px;
  font-weight: 400;
  color: rgba(60, 60, 60, 1);
}
.const .jtCon .j_tit span {
  width: 7px;
  height: 7px;
  border-radius: 7px;
  margin-right: 9px;
  background-color: #2878ff;
  display: inline-block;
  margin-top: -5px;
}
.const .jtCon .j_tit label {
  margin-left: 11px;
  font-size: 13px;
  font-weight: 400;
  color: rgba(196, 196, 196, 1);
}
.const .jtCon .j_con {
  font-size: 13px;
  font-weight: 400;
  color: rgba(164, 164, 164, 1);
  margin-left: 15px;
}
.const .jtCon .j_pic {
  margin-left: 15px;
  margin-top: 10px;
}

.const /deep/.el-pagination {
  margin-top: 15px;
  text-align: right;
  padding-bottom: 15px;
}
</style>